import {Injectable} from '@angular/core';
import {Equipment} from "../models/equipment";
import {PhysicalAssetManagerService} from "./physical-asset-manager.service";
import {RestApiManager} from "./rest-api-manager";
import {environment} from "@environments/environment";
import {Paginator} from "../models/paginator";
import {ResourceManager} from "./resource-manager";
import {Utils} from "../utils";
import {AccountManagerService} from "./account-manager-service";

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class EquipmentManagerService {

  constructor(
    private accountManager: AccountManagerService,
    private physicalAssetManagerService: PhysicalAssetManagerService,
    private resourceManager: ResourceManager,
    private restApiManager: RestApiManager
  ) { }

  async getEquipments(paginator?: Paginator<Equipment>): Promise<Equipment[]> {
    return this.restApiManager.getAll<Equipment>(
      Equipment,
      `${environment.restApi.endpoint}/companies/${this.accountManager.account.company.id}/equipment_models`,
      this.accountManager.account.authToken,
      { paginator }
    );
  }

  async getEquipment(equipmentId: string): Promise<Equipment> {
    return this.restApiManager.get<Equipment>(
      Equipment,
      `${environment.restApi.endpoint}/equipment_models/${equipmentId}`,
      this.accountManager.account.authToken
    );
  }

  async createEquipment(equipment: Equipment): Promise<Equipment> {
    return this.restApiManager.post<Equipment>(
      `${environment.restApi.endpoint}/equipment_models`,
      { ...equipment, companyId: this.accountManager.account.company.id },
        this.accountManager.account.authToken
    );
  }

  async updateEquipment(equipmentId: string, equipment: Equipment): Promise<Equipment> {

    return this.restApiManager.put<Equipment>(
      `${environment.restApi.endpoint}/equipment_models/${equipmentId}`,
      { ...equipment, companyId: this.accountManager.account.company.id },
      this.accountManager.account.authToken
    );

    // TODO Update all asset bind to current equipment
    /*const assets = await this.physicalAssetManagerService.getPhysicalAssets(equipmentId);
    await Promise.all(assets.map(async asset => {
      await this.db.collection('companies').doc(this.accountManager.companyId).collection('assets').doc(asset.uid).set({
        model: equipment.name
      }, { merge: true });
    }));*/

  }

  async removeEquipment(equipmentId: string): Promise<void> {

    return this.restApiManager.delete(
      `${environment.restApi.endpoint}/equipment_models/${equipmentId}`,
      this.accountManager.account.authToken
    );

    // TODO Remove all physical assets
    /*(await this.db.collection('companies').doc(this.accountManager.companyId).collection('assets').ref.where('equipment_id', '==', equipmentId).get()).docs.forEach(asset => {
      this.physicalAssetManagerService.removePhysicalAsset(asset.id);
    });*/
  }

  async uploadImageEquipment(equipmentId: string, image: File): Promise<void> {

    // Get signed upload url
    const data = await this.restApiManager.get(
      null,
      `${environment.restApi.endpoint}/equipment_models/${equipmentId}/image`,
      this.accountManager.account.authToken,
      {
        extension: Utils.getExtensionFromFile(image),
        content_type: image.type
      }
    );

    const bucket = data['bucket'];
    const objectName = data['objectName'];
    const contentType = data['contentType'];
    const url = data['url'];

    // Upload file
    await this.resourceManager.uploadResourceFile(url, image, image.type);

    // Set equipment image
    await this.restApiManager.patch<string>(
      `${environment.restApi.endpoint}/equipment_models/${equipmentId}/image`,
      { bucket, objectName, contentType },
      this.accountManager.account.authToken,
    );

  }

}
